export const i18nDefaults = {
    'enum.none': 'None'
}
